import { render, staticRenderFns } from "./CreateDepartman.vue?vue&type=template&id=d7165298"
import script from "./CreateDepartman.vue?vue&type=script&lang=js"
export * from "./CreateDepartman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports